// extracted by mini-css-extract-plugin
module.exports = {"container":"_2qp73","title":"_1inAe","content":"_10Fx3","links":"JfHua","button":"_3luVD"};